<div [class]="creditsAmountClass">
  <mat-icon class="credits-amount__icon" svgIcon="credits-pargo"></mat-icon>
  <span class="credits-amount__amount">{{ credits }}</span> credits
</div>
